module.exports = __webpack_public_path__ + "img/campana-alt.3700bafe.png";